// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__2bas6","content":"PageLayout_content__3QGQM","header":"PageLayout_header__bI9mF","deconnectionBtn":"PageLayout_deconnectionBtn__3FJS7"};